import styled from 'styled-components'

/**
 * TODO: replace with CheggUI icons
 */
// tslint:disable:no-var-requires
const trashIcon = require('../../assets/images/Trash.svg')
// tslint:disable:no-var-requires
const trashHoverIcon = require('../../assets/images/Trash-hover.svg')

interface DeleteProps {
  filename: string
}

const DeleteIcon = styled.button.attrs<DeleteProps>(props => ({
  'aria-label': `${props.filename}`,
}))<DeleteProps>`
  background-image: url(${trashIcon});
  height: 25px;
  width: 25px;
  background-repeat: no-repeat;
  border: none;
  cursor: pointer;
  &:hover {
    background-image: url(${trashHoverIcon});
  }
`

export default DeleteIcon



// WEBPACK FOOTER //
// ./src/pages/MyPapers/DeleteIcon.tsx